<div class="modal-header">
    <h4 class="modal-title drop-modal-title" id="modal-basic-title">ADD PAYMENT METHOD</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
    <p class="processing-fee-note" *ngIf="allowsBankPaymentMethods() && location && location.credit_card_surcharge && location.credit_card_surcharge > 0" class="mb-2">
        Avoid a {{location.credit_card_surcharge | number:'1.2-2'}}% processing fee by connecting your bank account
    </p>
    <!-- Loading indicator -->
    <div *ngIf="isLoading" class="text-center">
        <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2">Loading payment form...</p>
    </div>

    <!-- This is the container for the Stripe payment element -->
    <div id="payment-element" #paymentElement></div>

    <div class="mt-3">
        <label class="make-default">
            <input type="checkbox" [checked]="makeDefault" (change)="onMakeDefaultChange($event)" />
            Make this my default payment method
        </label>
    </div>
    
    <div *ngIf="errorMessage" class="error-message alert alert-danger mt-3">{{ errorMessage }}</div>
    <div *ngIf="successMessage" class="success-message alert alert-success mt-3">{{ successMessage }}</div>
</div>
<div class="modal-footer">
  <button
    *ngIf="showCloseButton"
    type="button"
    class="btn btn-dark reserve-spot-button"
    (click)="closeModal(true)"
    [disabled]="submitted"
  >
    Close
  </button>

  <button
    *ngIf="!showCloseButton"
    type="button"
    class="btn btn-dark reserve-spot-button"
    [disabled]="submitted || !paymentDetailsAdded"
    (click)="onSubmit()"
  >
      <div *ngIf="submitted" class="spinner-border" role="status">
          <span class="visually-hidden">Adding payment method...</span>
        </div>
        <span *ngIf="!submitted">ADD PAYMENT METHOD</span>
  </button>
</div>
